import React, { PropsWithChildren } from "react";
import { ErrorView } from "./error-view";

type ErrorBoundaryProps = PropsWithChildren<{}>;

export class ErrorBoundary extends React.Component<ErrorBoundaryProps> {
  public state: { hasError: boolean; text: string } = {
    hasError: false,
    text: "",
  };
  public timeout: NodeJS.Timeout | null = null;

  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false, text: "" };
  }

  public static getDerivedStateFromError(error: Error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, text: error.message ?? "An error has occurred" };
  }

  public componentDidCatch(_error: Error, _info: any) {
  }

  public render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return <ErrorView />;
    }
    return this.props.children;
  }
}
